import { render } from "./g-account-register.vue?vue&type=template&id=52b1e9fe&ts=true"
import script from "./g-account-register.vue?vue&type=script&lang=tsx"
export * from "./g-account-register.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__